export default {"src":"/_next/static/media/downloads.13706601.svg","height":19,"width":32,"blurWidth":0,"blurHeight":0};